import React from "react";
import { Box } from "@mui/material";
import _ from "lodash";
import {
  convertUtcToTimezone,
  formatDateTime,
  stripNumbersFromUsername,
} from "_helpers";
import TikTokShopContent from "components/v2/common/Message/TikTokShop/TikTokShopContent";

export default function MessageThread({
  conversation,
  currentUser,
  sourceName,
}) {
  const timezone = _.get(currentUser, "organization.timezone");

  return (
    <Box sx={styles.wrapper}>
      {conversation?.map((item) => {
        const text = item.text;
        const author = stripNumbersFromUsername(item.author);
        const direction = item.direction.toUpperCase();
        const datetime = formatDateTime(
          convertUtcToTimezone(item.createdDate, timezone),
        );

        const textContent = (
          <TikTokShopContent text={text} sourceName={sourceName} />
        );

        return (
          <Box
            key={item.id}
            sx={
              direction === "INCOMING"
                ? styles.leftBoxWrapper
                : styles.rightBoxWrapper
            }
          >
            <Box maxWidth="70%">
              <Box
                sx={
                  direction === "INCOMING"
                    ? styles.leftTextBox
                    : styles.rightTextBox
                }
              >
                {textContent}
              </Box>
              <Box
                sx={
                  direction === "INCOMING"
                    ? styles.timeStamp
                    : { ...styles.timeStamp, textAlign: "right" }
                }
              >
                {author} • {datetime}
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "rgb(250, 248, 244)",
    flex: 1,
    overflow: "auto",
    padding: "16px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  leftBoxWrapper: {
    display: "flex",
    justifyContent: "flex-start",
  },
  leftTextBox: {
    color: "#1a2b20",
    m: 0,
    fontFamily: "FustatRegular",
    fontSize: "14px",
    backgroundColor: "#FFFFFF",
    padding: "12px",
    border: "1px solid rgb(236, 231, 223)",
    borderRadius: "16px 16px 16px 4px",
    minWidth: "fit-content",
    maxWidth: "70%",
  },
  rightTextBox: {
    color: "#ffffff",
    m: 0,
    fontFamily: "FustatRegular",
    fontSize: "14px",
    backgroundColor: "#12321f",
    padding: "12px",
    border: "1px solid rgb(236, 231, 223)",
    borderRadius: "16px 16px 4px 16px",
    minWidth: "fit-content",
    maxWidth: "70%",
  },
  rightBoxWrapper: {
    display: "flex",
    justifyContent: "flex-end",
  },
  timeStamp: {
    color: "#495d5e",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "11px",
    mt: "4px",
  },
};
